import React, { useCallback, useState } from 'react';
import { Input, Popover } from 'antd';
import { ExpandOutlined } from '@ant-design/icons';

const { TextArea, Search } = Input;

/**
 * 高级搜索框（支持以逗号分隔的批量搜索，支持展开查看和修改）
 * @see https://4x.ant.design/components/form-cn/#components-form-demo-customized-form-controls
 */
const AdvancedSearch = ({ props, value, onChange, name, form, expand, onSearch }) => {
  // 展开配置，Object 格式，暂时只支持 title，有需求再添加其他属性
  const { title } = expand;
  const [textAreaValue, setTextAreaValue] = useState('');

  const handleTextAreaChange = useCallback(
    e => {
      setTextAreaValue(e.target.value);
      form.setFieldsValue({
        [name]: e.target.value.replace(/\n/g, ',').replace(/,\s*$/, ''),
      });
    },
    [name]
  );

  const handleSearchChange = useCallback(e => {
    onChange?.(e);
    setTextAreaValue(e.target.value.replace(/,|，|(\s+)/g, '\n'));
  }, []);

  const suffix = (
    <Popover
      title={title}
      content={
        <TextArea
          style={{ width: 250 }}
          rows={5}
          placeholder={`请输入${title}`}
          value={textAreaValue}
          onChange={handleTextAreaChange}
        />
      }
      trigger="click"
    >
      <ExpandOutlined style={{ cursor: 'zoom-in' }} />
    </Popover>
  );

  return <Search {...props} value={value} suffix={suffix} onChange={handleSearchChange} onSearch={onSearch} />;
};

export default AdvancedSearch;
